export default "__VITE_ASSET__B93uYZ9Q__"